<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div class="page-name color-71aa3f">
                        {{customerArr[0].first_name}} <span class="badge badge-info">{{ formatString(customerArr[0].status)}}</span>
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backShowCustomer">Back</button>
                </div>
                <div class="admin-page-content">
                    <div class="row">
                        <!--<div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <b-list-group>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Customer Name : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{customerArr[0].first_name}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>BillCusId : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{customerArr[0].billcusid}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Credit Limit : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{formatAmount(customerArr[0].amt_cr_limit)}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                            </b-list-group>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <b-list-group>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Total Due Amount : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{formatAmount(customerArr[0].total_due_amount)}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Last Paid Date : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{formatDate(customerArr[0].date_payment)}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Dunning Notice Activate : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{formatString(customerArr[0].dunning_notice)}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                            </b-list-group>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <b-button class="pull-right" v-b-toggle.collapse1 variant="link">View More...</b-button>
                            <div class="clearfix"></div>
                            <b-collapse id="collapse1" class="mt-2 mb-3">
                                <div class="row">
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <b-list-group>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>CusId : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{customerArr[0].cusid}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Description : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{customerArr[0].description}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Last Invoice Date : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{formatDate(customerArr[0].date_invoice)}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Last Invoice Amount : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{formatAmount(customerArr[0].amt_payment)}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Last Paid Amount : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{customerArr[0].due_days}} Days</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Past Due Term : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{formatAmount(customerArr[0].amt_cr_limit_invoice)}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Credit Limit On Invoice : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{formatAmount(customerArr[0].amt_aged0)}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Current Due : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{formatAmount(customerArr[0].amt_aged1to30)}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Due Over 1 To 30 Days : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{formatAmount(customerArr[0].amt_aged31to60)}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Due Over 31 To 60 Days : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{formatAmount(customerArr[0].amt_aged61to90)}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Due Over 61 To 90 Days : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{formatAmount(customerArr[0].amt_aged_over90)}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Due Over 90 Days : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{formatAmount(customerArr[0].amt_bal_open)}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Amount Balance Open : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{formatAmount(customerArr[0].amt_invoice)}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <b-list-group>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Customer Type : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{formatString(customerArr[0].customer_type)}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Registration Age : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{customerArr[0].reg_age_days}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                        <h4 class="color-23727b">Contact</h4>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Collector : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{customerArr[0].user_first_name}} {{customerArr[0].user_last_name}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Contact Name : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{customerArr[0].c_name}} {{customerArr[0].c_last_name}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Fax : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{customerArr[0].c_fax}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Job Title : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{customerArr[0].c_job_title}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Business Unit : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{customerArr[0].bu_home}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Description : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{customerArr[0].c_description}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Email : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{customerArr[0].contact_email}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Secondary Email : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{customerArr[0].contact_email2}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Phone : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{mobilenumber(mobilenumber(customerArr[0].contact_phone,3,'-'),7,'-')}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                                <div class="row">
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <strong>Secondary Phone : </strong>
                                                    </div>
                                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                        <span class="">{{mobilenumber(mobilenumber(customerArr[0].contact_phone2,3,'-'),7,'-')}}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>-->
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <div class="forms-container">
                                <h3 class="color-71aa3f">Customer Information </h3>
                                <b-list-group class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>Customer Name : </strong>
                                                <span class="">{{customerArr[0].first_name}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>BillCusId : </strong>
                                                <span class="">{{customerArr[0].billcusid}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>Credit Limit : </strong>
                                                <span class="">{{formatAmount(customerArr[0].amt_cr_limit)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                </b-list-group>
                                <b-list-group class="col-xl-6 col-lg-6 col-md-6 col-sm-12 pr-0">
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>Total Due Amount : </strong>
                                                <span class="">{{formatAmount(customerArr[0].total_due_amount)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>Last Paid Date : </strong>
                                                <span class="">{{formatDate(customerArr[0].date_payment)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <strong>Over Due Activate : </strong>
                                                <span class="">{{formatString(customerArr[0].dunning_notice)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                </b-list-group>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <b-button class="pull-right" v-b-toggle.collapse1 variant="link">View More...</b-button>
                                    <div class="clearfix"></div>
                                    <b-collapse id="collapse1" class="mt-2 mb-3">
                                        <div class="row">
                                            <b-list-group class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>CusId : </strong>
                                                            <span class="">{{customerArr[0].cusid}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Description : </strong>
                                                            <span class="">{{customerArr[0].description}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Last Invoice Date : </strong>
                                                            <span class="">{{formatDate(customerArr[0].date_invoice)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Last Invoice Amount : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_payment)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Last Paid Amount : </strong>
                                                            <span class="">{{customerArr[0].due_days}} Days</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Past Due Term : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_cr_limit_invoice)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Credit Limit On Invoice : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_aged0)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Current Due : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_aged1to30)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Due Over 1 To 30 Days : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_aged31to60)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Due Over 31 To 60 Days : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_aged61to90)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Due Over 61 To 90 Days : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_aged_over90)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Due Over 90 Days : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_bal_open)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Amount Balance Open : </strong>
                                                            <span class="">{{formatAmount(customerArr[0].amt_invoice)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                            </b-list-group>
                                            <b-list-group class="col-xl-6 col-lg-6 col-md-6 col-sm-12 pr-0">
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Customer Type : </strong>
                                                            <span class="">{{formatString(customerArr[0].customer_type)}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Registration Age : </strong>
                                                            <span class="">{{customerArr[0].reg_age_days}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <h4 class="color-23727b">Contact</h4>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <!-- <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Collector : </strong>
                                                            <span class="">{{customerArr[0].user_first_name}} {{customerArr[0].user_last_name}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item> -->
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Contact Name : </strong>
                                                            <span class="">{{customerArr[0].c_name}} {{customerArr[0].c_last_name}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Fax : </strong>
                                                            <span class="">{{customerArr[0].c_fax}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Job Title : </strong>
                                                            <span class="">{{customerArr[0].c_job_title}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Business Unit : </strong>
                                                            <span class="">{{customerArr[0].bu_home}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Description : </strong>
                                                            <span class="">{{customerArr[0].c_description}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Email : </strong>
                                                            <span class="">{{customerArr[0].contact_email}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Secondary Email : </strong>
                                                            <span class="">{{customerArr[0].contact_email2}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Phone : </strong>
                                                            <span class="">{{mobilenumber(mobilenumber(customerArr[0].contact_phone,3,'-'),7,'-')}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                                <b-list-group-item>
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <strong>Secondary Phone : </strong>
                                                            <span class="">{{mobilenumber(mobilenumber(customerArr[0].contact_phone2,3,'-'),7,'-')}}</span>
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                            </b-list-group>
                                        </div>
                                    </b-collapse>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <div class="forms-container">
                                <h3 class="color-71aa3f">Settings</h3>
                                <div class="row no-margin ml-0 mr-0">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide paddingleft0 pr-0">
                                        <div class="alert alert-success" id="alertSuccess">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span>Collector Updated Successfully</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide paddingleft0 pr-0">
                                        <div class="alert alert-danger" id="alertError">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span id="errorMsg" class="error"></span>
                                        </div>
                                    </div>
                                    <!-- <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 paddingleft0 ">
                                        <label class="form-label" for="user_id"><strong>Collector</strong></label>
                                    </div> -->
                                    <!-- <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 paddingleft0 pr-0">
                                        <v-select id="collector" v-model="user_id" @change="userChangedValue" name="user_id" label="text" :filterable="false" :options="usersArr" @search="onSearchUser" v-validate="'required'">
                                            <template slot="no-options">
                                                type to search Collector...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select><br/>
                                        <span v-show="errors.has('user_id')" class="help is-danger" v-if="errors.has('user_id')"><font color="red">Collector is Required</font></span>
                                    </div> -->
                                    <div class="clearfix"></div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 paddingleft0">
                                        <label class="form-label " for="user_id"><strong>Over Due Status</strong></label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 paddingleft0 form-label pr-0">
                                        <!--<v-select
                                            name="dunningNotice"
                                            v-model="dunningNotice"
                                            id="status" label="text"
                                            :options="dunningNoticeArr"
                                            :required="true"
                                            :value="dunningNotice"
                                            v-validate="'required'"
                                            ></v-select><br/>-->
                                        <b-form-radio-group v-model="dunningNotice"
                                                            :options="dunningNoticeArr"
                                                            name="dunningNotice">
                                        </b-form-radio-group>
                                        <!--{{dunningNotice}}-->
                                        <span v-show="errors.has('dunningNotice')" class="help is-danger" v-if="errors.has('dunningNotice')"><font color="red">Dunning Notice Status is Required.</font></span>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 paddingleft0 pr-0">
                                        <input id="addCaseBtn" type="submit" value="Update" class="btn general-button btn-primary" v-on:click.prevent="updateCollector()">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <app-contact :contactPageData='contactPage'></app-contact>
                <app-call :callPageData='callPage'></app-call>
                <app-task :taskPageData='taskPage'></app-task>
                <app-resale :resalePageData='resalePage'></app-resale>
                <app-case :casePageData='casePage'></app-case>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>
<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {list_taskUrl} from '../../config';
    import FrontFooter from '@/components/partials/FrontFooter';
    import ListContactComponent from "@/components/contact/ListContactComponent";
    import ListTasksComponent from "@/components/task/ListTasksComponent";
    import ListReshaleComponent from "@/components/resale/ListReshaleComponent";
    import ListCallsComponent from "@/components/callsAndEmails/ListCallsComponent";
    import CaseListComponent from "@/components/cases/CaseListComponent";
    import VeeValidate from 'vee-validate';
    import EventBus from '../event-bus';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');
    Vue.use(VeeValidate);
    import SessioMixin from '../../mixins/sessionmixin';
    export default {
        name: 'CustomerView',
        mixins: [SessioMixin],
        components: {
            'app-resale': ListReshaleComponent,
            'app-task': ListTasksComponent,
            'app-call': ListCallsComponent,
            'app-case': CaseListComponent,
            'app-contact': ListContactComponent,
            'app-footer': FrontFooter,
        },
        data() {
            return{
                taskPage: {
                    pageTitle: 'Customer Tasks',
                    perPage: 5,
                    cus_id: 0,
                    is_part: 1,
                },
                resalePage: {
                    pageTitle: 'Customer Resale',
                    perPage: 5,
                    cus_id: 0,
                    is_part: 1,
                    sv_tax_id: '',
                    pt_tax_id: '',
                    is_cust_detail: true,
                },
                callPage: {
                    pageTitle: 'Customer Call/Email',
                    perPage: 5,
                    cus_id: 0,
                    is_part: 1,
                },
                casePage: {
                    pageTitle: 'Customer Cases',
                    perPage: 5,
                    cus_id: 0,
                    is_part: 1,
                },
                contactPage: {
                    pageTitle: 'Customer Contacts',
                    perPage: 2,
                    cus_id: 0,
                    is_part: 1,
                },
                messageCase: 'all',
                loginID: 0,
                permissions: [],
                cantAccessPage: true,
                isLoggedIn: false,
                customerArr: [[]],
                user_id: "",
                cus_id: "",
                dunningNotice: "active",
                dunningNoticeArr: [
                    {
                        value: 'active', text: "Active"
                    },
                    {
                        value: 'inactive', text: "Inactive"
                    }
                ],
                usersArr: [],
                firstLoad: 0,
                columnsCase: [
                    {
                        label: 'Case ID',
                        field: 'id',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "ID", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    // {
                    //     label: 'Collector',
                    //     field: 'collector_user_full_name',
                    //     filterable: true,
                    //     filterOptions: {
                    //         enabled: true, // enable filter for this column
                    //         placeholder: "Collector", // placeholder for filter input
                    //         filterValue: '', // initial populated value for this filter
                    //         trigger: "enter" //only trigger on enter not on keyup
                    //     }
                    // },
                    {
                        label: 'CusId',
                        field: 'cusid',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Customer Name',
                        field: 'customer_firstname',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Assigned Internal User',
                        field: 'assigned_internal_user',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Assigned Internal User", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Status", // placeholder for filter input
                            filterDropdownItems: ['Open', 'In Progress', 'Resolved', 'Closed'], // dropdown (with selected values) instead of text input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Priority',
                        field: 'priority',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Priority", // placeholder for filter input
                            filterDropdownItems: ['Low', 'Normal', 'High'], // dropdown (with selected values) instead of text input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Reported On',
                        field: 'created_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "From | To", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        sortable: false,
                        thClass: 'disable-sorting',
                    }

                ],
                rowsCase: [],
                totalRecordsCase: 0,
                serverParamsCase: {
                    columnFilters: {

                    },
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 5
                },
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                app.loadCustomer();
                var path = window.location.pathname;
                var segments = path.split("/");
                app.contactPage.cus_id = app.casePage.cus_id = app.taskPage.cus_id = app.resalePage.cus_id = app.callPage.cus_id = segments[3];
                app.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            $(".removeActive").removeClass('active');
            $("#menucustomers").addClass('active');
            var self = this;
            self.showLoader();
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            //self.loadCustomer();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }

        },
        methods: {
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        $(".removeActive").removeClass('active');
                        $("#menucustomers").addClass('active');
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_customer_view') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        $(".removeActive").removeClass('active');
                        $("#menucustomers").addClass('active');
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            loadCustomer() {

                var path = window.location.pathname;
                var segments = path.split("/");
                //console.log(segments[3]);
                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/getcustomers/" + segments[3],
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        //console.log(data[0]);
                        self.customerArr = data.content;
                        self.user_id = {value: data.content[0].user_id, text: data.content[0].user_first_name + " " + data.content[0].user_last_name/* + " - " + data.content[0].user_email*/}
                        /*self.dunningNotice = {value: data.content[0].dunning_notice, text: self.formatString(data.content[0].dunning_notice)}*/
                        self.dunningNotice = data.content[0].dunning_notice;
                        // self.user_id = {value : self.customerArr.user_id, text : self.customerArr.user_first_name };
                        // console.log(self.user_id);
                        self.cus_id = data.content[0].cusid;
                        self.resalePage.pt_tax_id = data.content[0].pt_tax_id;
                        self.resalePage.sv_tax_id = data.content[0].sv_tax_id;
                        self.loadCases();
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            backShowCustomer() {
                var self = this;
                self.$router.push('/listcustomer');

            },
            userChangedValue: function (value) {

                //console.log("", value);
            },
            onSearchUser(search, loading) {
                if (search.length > 1) {
                    loading(true);
                    this.loadUser(loading, search, this);
                }
            },
            loadUser(loading, search, vm) {

                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/users",
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search,
                        type: 'collector',
                    },
                    dataType: 'json',
                    success: function (data) {
                        loading(false);

                        self.usersArr = data;

                        //console.log(self.usersArr);
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                })

            },
            updateCollector() {
                this.$validator.validate().then(result => {
                    if (result) {
                        var self = this;
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        //console.log(self.user_id.value);
                        //console.log(segments[3]);
                        self.showLoader();

                        // var fields = $('#collector').serializeArray();
                        // fields.push({name: 'user_id', value: self.user_id.value});


                        $.ajax({
                            url: process.env.ROOT_API + "/update/collector/" + segments[3],
                            type: "POST",
                            data: {user_id: self.user_id.value, dunningNotice: self.dunningNotice, custId: segments[3]},
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                self.hideLoader();
                                //console.log(data);

                                $(".alert-success").html(data.message);
                                $(".alert-success").parent().removeClass('hide');
                                $(".alert-success").parent().addClass('show');
                                setTimeout(function () {
                                    $('.alert-success').parent().removeClass('show');
                                    $('.alert-success').parent().addClass('hide');
                                }, 5000);
                                if (data.status == 'success') {
                                    //console.log(data.content);


                                } else {
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        setTimeout(function () {
                                            $('.alert-danger').parent().removeClass('show');
                                            $('.alert-danger').parent().addClass('hide');
                                        }, 5000);
                                    }
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    $("#errorMsg").html(jqXHR.responseJSON.message);
                                    $(".alert-danger").parent().removeClass('hide');
                                    $(".alert-danger").parent().addClass('show');
                                    setTimeout(function () {
                                        $('.alert-danger').parent().removeClass('show');
                                        $('.alert-danger').parent().addClass('hide');
                                    }, 5000);
                                }
                            }
                        });

                    }
                });
            },
            formatString(data) {
                var self = this;
                if (typeof (data) != 'undefined') {
                    var value = data.replace(/_/g, " ");
                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;
                } else {
                    return false;
                }
            },
            formatDate(date) {
                if (typeof (date) != 'undefined') {
                    date = date.split(" ");
                    date = date[0];
                    var d = new Date(date);
                    var month = '' + (d.getMonth() + 1);
                    var day = '' + d.getDate();
                    var year = d.getFullYear();
                    if (month.length < 2)
                        month = '0' + month;
                    if (day.length < 2)
                        day = '0' + day;
                    return [month, day, year].join('/');
                } else {
                    return false;
                }
            },
            mobilenumber(string, position, addstring) {
                if ($.trim(string) === "" && $.trim(string).length <= 0) {
                    return string;
                } else {
                    return [string.slice(0, position), addstring, string.slice(position)].join('');
                }
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            allClickCase: function () {
                var self = this;
                self.messageCase = 'all';
                self.loadCases();
            },
            myClickCase: function () {
                var self = this;
                self.messageCase = 'my';
                self.loadCases();
            },
            loadCases: function () {
                var self = this;

                var fields = {
                    page: self.serverParamsCase.page,
                    perPage: self.serverParamsCase.perPage,
                    filters: self.serverParamsCase.columnFilters,
                    messageData: self.messageCase,
                    sort: self.serverParamsCase.sort,
                    exportFiltered: self.exportFilteredFlag,
                    cusid: self.cus_id
                };

                this.firstLoad = 1;
                // console.log(self.serverParamsCase.perPage);
                $.ajax({
                    url: process.env.ROOT_API + "/case/list",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        self.exportFilteredFlag = false;
                        if (data.message == 'success' || data.message == 'error') {
                            self.rowsCase = data.content.row;
                            self.totalRecordsCase = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                        if (data.message == "success export") {
                            //console.log(data.content.web);
                            $('#exportCase').html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                            $('#exportCase').prop("disabled", false);
                            self.downloadFile(data.content.web);
                            // location.href = data.content.web;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }


                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            updateParamsCase(newProps) {
                this.serverParamsCase = Object.assign({}, this.serverParamsCase, newProps);
            },
            //
            onPageChangeCase(params) {
                this.updateParamsCase({page: params.currentPage});

                this.loadCases();
            },
            //
            onPerPageChangeCase(params) {
                this.updateParamsCase({perPage: params.currentPerPage});
                this.totalRecordsCase = self.totalRecordsCase;
                this.loadCases();
            },

            onColumnFilterCase(params) {
                this.updateParamsCase(params);

                {
                    field: ('id');
                    field: ('collector_user_full_name');
                    field: ('assigned_internal_user');
                    field:('status');
                    field:('priority');
                    field:('cusid');
                    field:('customer_firstname');
                    field:('created_at');
                }
                ;
                this.serverParamsCase.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParamsCase));
                var filters = filtersPr.columnFilters;

                if (this.firstLoad == 1 || filters.id || filters.collector_user_full_name || filters.assigned_internal_user
                        || filters.status || filters.priority || filters.cusid || filters.customer_firstname || filters.created_at) {
                    this.loadCases();
                }

            },
            selectionChangedCase() {

                var self = this;
                // console.log( this.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            onSortChangeCase(params) {
                this.updateParamsCase({
                    sort: {
                        type: params.sortType,
                        field: this.columnsCase[params.columnIndex].field,
                        /*type: params[0].type,
                         field: params[0].field,*/
                    },
                });
                this.loadCases();
            },
            formatAmount(amt) {
                amt += '';
                var x = amt.split('.');
                var x1 = x[0];
                var x2 = x.length > 1 ? '.' + x[1] : '.' + '00';
                if (x2.length == 2) {
                    x2 = x2 + "0";
                }
                var rgx = /(\d+)(\d{3})/;
                while (rgx.test(x1)) {
                    x1 = x1.replace(rgx, '$1' + ',' + '$2');
                }
                return process.env.CURRENCY_SYMBOL + x1 + x2;
            },

        },

    }
</script>



// WEBPACK FOOTER //
// src/components/customer/CustomerView.vue